import styled from "styled-components"; 

const spanstyle = `
background: linear-gradient(257.94deg, #001019 18.65%, #014E7A 86.55%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
background-clip: text;
text-align: center;
`;
export const ContainerTurnoRecepcionado = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
    gap: 50px; 
    width: 100vw;
    .title {
        font-weight: 700;
        font-size: 36px;
        line-height: 150%;
        ${spanstyle}
    }
    .subtitle {
        font-weight: 400;
        font-size: 28px;
        line-height: 150%; 
        width: 80%;
        ${spanstyle}
    }
    button {
        width: 211px;
        height: 49px;
        background: var(--color-danger);
        border-radius: 8px;
        font-size: 18px;
        color: var(--color-white);
    }
`; 